/**
 * Primitives.jsx - the small drawn pieces of the sign-off sheet: wordmark,
 * progress bar, status mark, dot leader and the status key.
 */
import { AMBER_MARK, GREEN, GREY, GREY_LIGHT, LEADER, TRACK } from './theme';

export function Wordmark() {
  return (
    <div style={{ lineHeight: 1, flexShrink: 0 }}>
      <span style={{ fontSize: 25, fontWeight: 800, color: GREEN, letterSpacing: '0.4px' }}>GLOBAL</span>
      <span
        style={{
          display: 'block',
          fontSize: 8.5,
          fontWeight: 700,
          color: GREY,
          letterSpacing: '3.1px',
          textTransform: 'uppercase',
          marginTop: 5,
        }}
      >
        Automation Technologies
      </span>
    </div>
  );
}

export function Bar({ pct, height }) {
  return (
    <div
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      style={{
        width: '100%',
        height: height || 6,
        background: TRACK,
        borderRadius: 0,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: Math.max(pct, pct > 0 ? 1 : 0) + '%',
          height: '100%',
          background: GREEN,
          borderRadius: 0,
        }}
      />
    </div>
  );
}

export function Mark({ status }) {
  const base = {
    width: 9,
    height: 9,
    display: 'inline-block',
    flexShrink: 0,
    borderRadius: 0,
    boxSizing: 'border-box',
  };
  if (status === 'done') return <span aria-hidden="true" style={{ ...base, background: GREEN }} />;
  if (status === 'na') return <span aria-hidden="true" style={{ ...base, background: AMBER_MARK }} />;
  return <span aria-hidden="true" style={{ ...base, border: '1px solid ' + GREY_LIGHT }} />;
}

export function Leader() {
  return (
    <span
      aria-hidden="true"
      style={{
        flex: '1 1 14px',
        minWidth: 10,
        height: 0,
        borderBottom: '1px dotted ' + LEADER,
        transform: 'translateY(-2px)',
      }}
    />
  );
}

export function KeyItem({ status, label }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <Mark status={status} />
      {label}
    </span>
  );
}

export function StatusKey() {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '7px 20px',
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        color: GREY,
        paddingTop: 9,
      }}
    >
      <span style={{ color: GREY_LIGHT }}>Key</span>
      <KeyItem status="done" label="Signed" />
      <KeyItem status="na" label="Not applicable" />
      <KeyItem status="pending" label="Pending" />
    </div>
  );
}

/* -------------------------------- title block -------------------------------- */
